import { render } from "./Callout.vue?vue&type=template&id=76c4cbad&scoped=true"
import script from "./Callout.vue?vue&type=script&lang=js"
export * from "./Callout.vue?vue&type=script&lang=js"

import "./Callout.vue?vue&type=style&index=0&id=76c4cbad&lang=scss&scoped=true"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c4cbad"]])

export default __exports__